// Alternate (secondary) email addresses.
//
// team_members.alternate_emails holds a JSON array of addresses —
// ["a@x.com","b@y.com"] — so one column carries any number of them. Rows
// written before the column existed, or edited by hand, can hold a plain
// comma/semicolon separated list, so the parser accepts that shape too.

/** Loose format check — same rule the wizard uses for the primary email. */
export const EMAIL_RE = /^\S+@\S+\.\S+$/;

/**
 * Stored value → array of addresses. Never throws; anything unreadable
 * comes back as an empty list rather than breaking the page that renders it.
 *
 * @param {string|string[]|null|undefined} raw
 * @returns {string[]}
 */
export const parseAlternateEmails = (raw) => {
  if (Array.isArray(raw)) {
    return raw.map((e) => String(e || "").trim()).filter(Boolean);
  }
  const str = String(raw ?? "").trim();
  if (!str || str === "null" || str === "[]") return [];
  if (str.startsWith("[")) {
    try {
      const parsed = JSON.parse(str);
      if (Array.isArray(parsed)) {
        return parsed.map((e) => String(e || "").trim()).filter(Boolean);
      }
    } catch {
      /* not JSON after all — fall through to the split below */
    }
  }
  return str
    .split(/[,;]/)
    .map((e) => e.trim())
    .filter(Boolean);
};
